exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".makbuzaltimza[data-v-50978475]{width:5cm;padding:10px;border:1px dashed #ccc;text-align:center;margin-top:10px;height:3cm}.makbuzaltimza small[data-v-50978475]{opacity:.5;line-height:10px;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50978475","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Vezne/Makbuz/Fisler.vue
// module id = 432
// module chunks = 0